<template>
  <div class="wrapper-inside">
    <div class="container">
      <div class="row text-left">
        <div class="col-12 col-lg-4">
          <img
            src="../assets/404.png"
            class="img-fluid"
          >
        </div>
        <div class="col-12 col-lg-8 m-auto">
          <h1>{{ $t('pages.not-found.title') }}</h1>
          <p>
            {{ $t('pages.not-found.subtitle') }}
          </p>
          <b-button
            variant="info"
            class="buscar-btn"
            @click="searchOffers"
          >
            {{ $t('pages.not-found.search-offers') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    searchOffers() {
      this.$router.push({ name: 'home' })
    }
  },
  metaInfo: {
      title: 'No hemos encontrado esta página',
      titleTemplate: '%s - ' + process.env.VUE_APP_NAME,
      meta: [
          { vmid: "description", name: "description", content: "The page you were looking for could not be found" },
          { vmid: "og:title", name: "og:title", content: "Page not found" },
          { vmid: "og:description", name: "og:description", content: "The page you were looking for could not be found" },
          { vmid: "robots", name: "robots", content: "noindex,nofollow" },
      ]
  },
}
</script>


<style lang="scss">
.buscar-btn {
  text-transform: uppercase;
  font-size: 0.8rem;
}
</style>
